import styled from '@emotion/styled'
import { WHITE } from '../../constant/colors'
import { useGetOrder } from '../../services/cart/cart-query'

const Layout = styled.div``

const Section = styled.div`
  margin: 16px 0;
  padding: 16px;
  background: ${WHITE};
`

const Order = () => {
  const { data: order } = useGetOrder()

  return (
    <Layout>
      {order?.map((data, index) => (
        <Section>
          <div key={index}>Order #{data.orderCode}</div>
        </Section>
      ))}
    </Layout>
  )
}

export default Order
